<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <h3>Add New User</h3>
        </v-card-title>
        <v-card-text>
          <v-alert type="error" :value="error.status" dismissible>
            {{error.message}}
          </v-alert>
          <v-alert type="success" :value="success.status" dismissible>
            {{success.message}}
          </v-alert>
          <v-form @submit.prevent="create" ref="userForm">
            <v-radio-group v-model="table">
              <v-radio label="Dealer" value="channel-partners"></v-radio>
              <v-radio label="Sales Person" value="sales-partners"></v-radio>
            </v-radio-group>
            <v-text-field
              color="accent"
              :disabled="loading"
              :label="codeLabel"
              :placeholder="`Enter ${codeLabel}`"
              :rules="[(v) => !!v || `${codeLabel} is required`]"
              v-model="code"
            ></v-text-field>
            <v-text-field
              color="accent"
              :disabled="loading"
              label="Dealer Name"
              placeholder="Enter Dealer Name"
              v-model="name"
              :rules="[(v) => !!v || `${nameLabel} is required`]"
            ></v-text-field>
            <v-text-field
              color="accent"
              :disabled="loading"
              label="Dealer Email"
              placeholder="Enter Dealer Email"
              type="email"
              :rules="emailRules"
              v-model="email"
              v-if="table === null || table === 'channel-partners'"
            ></v-text-field>
            <v-text-field
              color="accent"
              :disabled="loading"
              :label="phoneLabel"
              :rules="phoneRules"
              :placeholder="`Enter ${phoneLabel}`"
              v-model="phone"
            ></v-text-field>
            <v-autocomplete
              :label="typeLabel"
              :items="customerTypes"
              :rules="[(v) => !!v || `${typeLabel} is required`]"
              color="accent"
              :disabled="loading"
              return-object
              v-model="type"
            ></v-autocomplete>
            <v-btn type="submit" color="accent" :disabled="loading" :loading="loading">Add New User</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import customerTypes from '../../../customerTypes.json';

export default {
  data() {
    return {
      loading: false,
      error: {
        status: false,
        message: '',
      },
      success: {
        status: false,
        message: '',
      },
      customerTypes,
      table: 'channel-partners',
      code: null,
      email: null,
      name: null,
      phone: null,
      type: null,
    };
  },
  methods: {
    async create() {
      // here we will create a new user
      this.error.status = false;
      this.success.status = false;
      if (this.table === null) {
        this.error.message = 'Please select the User Type e.g. Dealer or Sales Person';
        this.error.status = true;
      }
      if (this.table !== null && this.$refs.userForm.validate()) {
        this.loading = true;
        try {
          await this.firebase.firestore().collection(this.table).doc(this.code).set({
            code: this.code,
            name: this.name,
            email: this.email,
            phone: this.phone,
            type: this.type.value,
            description: this.type.text,
          });
          this.loading = false;
          this.success.message = `${this.name} added successfully`;
          this.success.status = true;
          this.$refs.userForm.resetValidation();
          this.resetForm();
        } catch (error) {
          this.error.message = 'Something went wrong. Please try in some time.';
          this.error.status = true;
          this.loading = false;
        }
      }
      // console.log(this.$refs.userForm.validate());
    },
    resetForm() {
      this.email = null;
      this.code = null;
      this.name = null;
      this.phone = null;
      this.type = null;
    },
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || `${this.emailLabel} is required`,
        (v) => v === null || (v.length === 0) || /.+@.+\..+/.test(v) || `${this.phoneLabel} must be valid`,
      ];
    },
    phoneRules() {
      return [
        (v) => !!v || `${this.phoneLabel} is required`,
        (v) => v === null || (v.length === 10) || `${this.phoneLabel} must be 10 characters`,
      ];
    },
    codeLabel() {
      let lable = '';
      if (this.table === null || this.table === 'channel-partners') {
        lable = 'Dealer Code';
      }
      if (this.table === 'sales-partners') {
        lable = 'Sales Employee Code';
      }
      return lable;
    },
    nameLabel() {
      let lable = '';
      if (this.table === null || this.table === 'channel-partners') {
        lable = 'Dealer Name';
      }
      if (this.table === 'sales-partners') {
        lable = 'Sales Employee Name';
      }
      return lable;
    },
    phoneLabel() {
      let lable = '';
      if (this.table === null || this.table === 'channel-partners') {
        lable = 'Dealer Phone';
      }
      if (this.table === 'sales-partners') {
        lable = 'Sales Employee Phone';
      }
      return lable;
    },
    emailLabel() {
      let lable = '';
      if (this.table === null || this.table === 'channel-partners') {
        lable = 'Dealer Email';
      }
      if (this.table === 'sales-partners') {
        lable = 'Sales Employee Email';
      }
      return lable;
    },
    typeLabel() {
      let lable = '';
      if (this.table === null || this.table === 'channel-partners') {
        lable = 'Dealer Type';
      }
      if (this.table === 'sales-partners') {
        lable = 'Sales Employee Type';
      }
      return lable;
    },
  },
};
</script>
